<div class="app-multi-select-wrapper" [ngClass]="customClass">
  <!-- Header Label -->
  <app-label
    *ngIf="resolvedLabel"
    [text]="resolvedLabel"
    [mandatory]="isRequired"
    [optional]="optional"
    [tooltip]="tooltip"
    [icon]="labelIcon"
    [size]="labelSize"
  ></app-label>

  <!-- Trigger Box -->
  <div
    class="app-multi-select-trigger"
    [ngClass]="[
      'app-multi-select-trigger--' + (size || 'md'),
      isOpen ? 'app-multi-select-trigger--open' : '',
      hasError ? 'app-multi-select-trigger--error' : '',
      disabled ? 'app-multi-select-trigger--disabled' : '',
      containerClass
    ]"
    [style.height]="resolvedHeight ? resolvedHeight : null"
    [style.minHeight]="resolvedHeight ? resolvedHeight : null"
    (click)="toggleDropdown($event)"
  >
    <!-- Value / Chips Display -->
    <div class="app-multi-select__value-display">
      <ng-container *ngIf="selectedOptions.length > 0; else emptyPlaceholder">
        <div class="app-multi-select__chips-wrap">
          <span
            *ngFor="let opt of selectedOptions"
            class="app-multi-select__chip"
            (click)="$event.stopPropagation()"
          >
            <span class="app-multi-select__chip-label">{{ opt.label }}</span>
            <button
              type="button"
              class="app-multi-select__chip-remove"
              [disabled]="disabled"
              (click)="removeOption(opt.value, $event)"
              title="Remove"
            >
              <svg width="10" height="10" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                <line x1="2" y1="2" x2="12" y2="12"></line>
                <line x1="12" y1="2" x2="2" y2="12"></line>
              </svg>
            </button>
          </span>
        </div>
      </ng-container>

      <ng-template #emptyPlaceholder>
        <span class="app-multi-select__placeholder">
          {{ placeholder }}
        </span>
      </ng-template>
    </div>

    <!-- Actions (Chevron) -->
    <div class="app-multi-select__actions">
      <span class="app-multi-select__chevron" [ngClass]="{ 'app-multi-select__chevron--open': isOpen }">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M7 10l5 5 5-5z"/>
        </svg>
      </span>
    </div>

    <!-- Popover Dropdown Menu -->
    <div *ngIf="isOpen" class="app-multi-select__dropdown" (click)="$event.stopPropagation()">
      <!-- Search Input -->
      <div *ngIf="searchable" class="app-multi-select__search-box">
        <div class="app-multi-select__search-wrap">
          <svg width="14" height="14" viewBox="0 0 16 16" fill="#9AA9BE" class="app-multi-select__search-icon">
            <path
              d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
            />
          </svg>
          <input
            type="text"
            class="app-multi-select__search-input"
            [placeholder]="searchPlaceholder"
            [value]="searchTerm"
            (input)="onSearchInput($event)"
            (click)="$event.stopPropagation()"
            autofocus
          />
        </div>
      </div>

      <!-- Options List with Reusable Checkboxes -->
      <div class="app-multi-select__options-list">
        <div
          *ngFor="let opt of filteredOptions"
          class="app-multi-select__option"
          [ngClass]="{
            'app-multi-select__option--selected': isSelected(opt.value),
            'app-multi-select__option--disabled': isOptionDisabled(opt)
          }"
          (click)="toggleOption(opt, $event)"
        >
          <app-checkbox
            [checked]="isSelected(opt.value)"
            [disabled]="isOptionDisabled(opt)"
            tabindex="-1"
            style="pointer-events: none;"
          ></app-checkbox>

          <div class="app-multi-select__option-content">
            <span class="app-multi-select__option-label">{{ opt.label }}</span>
            <span *ngIf="opt.sublabel" class="app-multi-select__option-sublabel">{{ opt.sublabel }}</span>
          </div>
        </div>

        <div *ngIf="filteredOptions.length === 0" class="app-multi-select__no-options">
          No options found
        </div>
      </div>
    </div>
  </div>

  <!-- Error Message -->
  <div *ngIf="hasError" class="app-multi-select__error">
    {{ errorMsg }}
  </div>

  <!-- Helper Text -->
  <div *ngIf="helperText && !hasError" class="app-multi-select__helper">
    {{ helperText }}
  </div>
</div>
